import moment from "moment";
import { decimalFormatter, longDecimalFormatter, setCurrency, setLongCurrency } from "@/utils/numberFormatter";
import { Link } from "react-router-dom";
import { ReactComponent as PdfIcon } from '@/icons/circlePDF.svg';

interface MovementsTableProps
{
    movements: any[],
    downloadBase64Pdf: (event: any, operationId: string) => void
}

const MovementsTable = (props: MovementsTableProps) => {
    return <table style={{tableLayout: "fixed", width: "100%"}}>
        <thead>
            <tr>
                <th style={{width: "100px"}}>Fecha VL</th>
                <th style={{width: "115px"}}>Fecha Liquidación</th>
                <th>Producto</th>
                <th>Descripción</th>
                <th style={{width: "100px"}}>Participaciones</th>
                <th style={{width: "70px"}}>Precio</th>
                <th style={{width: "95px"}}>Tipo de cambio</th>
                <th style={{width: "100px"}}>Importe Total</th>
                <th style={{width: "101px"}}></th>
            </tr>
        </thead>
        {props.movements.map((movement, index) => (
            <tr key={index}>
                <td style={{textAlign: "center"}}>{moment(movement.operationAt).format('DD/MM/YYYY')}</td>
                <td style={{textAlign: "center"}}>{moment(movement.settlementDate).format('DD/MM/YYYY')}</td>
                <td>
                    <Link to={`/${movement.operationInstrument.isin}`}>
                        {movement.operationInstrument.isin} - {movement.operationInstrument.name}
                    </Link>
                </td>
                <td>{movement.cashIn ? movement.description : movement.title}</td>
                <td style={{textAlign: "right"}}>{longDecimalFormatter.format(movement.titles)}</td>
                <td style={{textAlign: "right"}}>{setLongCurrency(movement.currency, movement.nav)}</td>
                <td style={{textAlign: "right"}}>{movement.exchangeRate === 1 ? movement.exchangeRate : decimalFormatter.format(movement.exchangeRate)}</td>
                <td style={{textAlign: "right"}}>{setCurrency(movement.currency, movement.amount)}</td>
                <td style={{textAlign: "center"}}>
                    <a href={'#' + movement.description} onClick={(event) => props.downloadBase64Pdf(event, movement.id)}>
                        <PdfIcon />
                    </a>
                </td>
            </tr>
        ))}
    </table>
};

export default MovementsTable;